import { URI } from '@fiverr-private/futile';
import { isGigPaused } from '../gigStatus';
import {
    ALLOWED_CATEGORIES,
    ALLOWED_CURRENT_USER_STATUSES,
    ALLOWED_SUB_CATEGORIES,
    RESTRICTED_GIG_STATUS
} from '../../components/PackagesTabs/CustomOrderTab/config';

export const inAllowedCategory = ({ categoryId, subCategoryId, inCustomOrderPackageTest }) =>
    inCustomOrderPackageTest ||
    !(!ALLOWED_CATEGORIES.includes(categoryId) && !ALLOWED_SUB_CATEGORIES.includes(subCategoryId));

/**
 * @param currentUserStatus
 * @param currentUser
 * @param inCustomOrderPackageTest
 *
 * @returns {boolean} Whether the user status is allowed.
 * In case the user is a guest return true by default.
 */
export const isAllowedUserStatus = ({ currentUserStatus, currentUser, inCustomOrderPackageTest }) => {
    if (!currentUser || (!currentUserStatus && inCustomOrderPackageTest)) {
        return true;
    }

    return ALLOWED_CURRENT_USER_STATUSES.includes(currentUserStatus);
};

export const shouldRenderCustomOrder = ({
    customOrder,
    general,
    currentUser,
    inCustomOrderPackageTest = false
}) => {
    const {
        gigStatus,
        isStudio,
        categoryId,
        subCategoryId,
        traffiqed,
        isOnVacation
    } = general;
    const { currentUserStatus, allowCustomOrders } = customOrder;

    return inAllowedCategory({ categoryId, subCategoryId, inCustomOrderPackageTest }) &&
        isAllowedUserStatus({ currentUserStatus, currentUser, inCustomOrderPackageTest }) &&
        !RESTRICTED_GIG_STATUS.includes(gigStatus) &&
        allowCustomOrders &&
        !isGigPaused(gigStatus, traffiqed) &&
        !isStudio &&
        !isOnVacation;
};

export const getCustomPackageRedirectUrl = () => {
    const uri = new URI(window.location.href);

    uri.addParams({
        custom_package: 'true'
    });

    return uri.toString();
};
